<template>

    <div id="classificationPlanPrint">

        <TreeStructureForPrint
                id="treeStructure"
                :classificationPlan="classificationPlan"
                :printMode="true"
                class="table"
        ></TreeStructureForPrint>

    </div>


</template>

<script type="text/javascript">
    import Vue from 'vue';
    import {library} from '@fortawesome/fontawesome-svg-core'
    import {faHome} from '@fortawesome/free-solid-svg-icons'
    import SidebarNavigation from '../components/SidebarNavigation';
    import {VueGoodTable} from 'vue-good-table';
    import axios from 'axios/index';
    import TreeStructureForPrint from '../components/TreeStructureForPrint';

    library.add(faHome);


    export default {
        name: 'ClassificationPlanPrint',
        props: ['from'],
        components: {
            SidebarNavigation,
            TreeStructureForPrint
        },
        data() {
            return {
                classificationPlan: this.$store.getters.getClassificationPlanFilteredAndChecked,
                classificationPlanPrint: [],
            }

        },
        mounted() {
            const _this = this;

            _this.setupPrintProperties('landscape');


            setTimeout(function () {

                //window.print();

                if(navigator.userAgent.toLowerCase().indexOf('chrome') > -1){   // Chrome Browser Detected?
                    window.PPClose = false;                                     // Clear Close Flag
                    window.onbeforeunload = function(){                         // Before Window Close Event
                        if(window.PPClose === false){                           // Close not OK?
                            return this.$t('text.classificationPlanPrint.leavePageWarning');
                        }
                    }
                    window.print();                                             // Print preview
                    window.PPClose = true;                                      // Set Close Flag to OK.
                } else {
                    window.print();
                }


                setTimeout(function () {
                    _this.$store.dispatch("setFilters", {
                        label: "none", labelName: "none", povezaniSistemi: "none", rokHrambe: "none",
                        vrstaGradiva: "none", vpisnik: "none", creationDate: "none", usageEndDate: "none"
                    });
                    _this.$store.dispatch("setClassificationPlanFiltered", []);
                    _this.$store.dispatch("setClassificationPlanFilteredAndChecked", []);

                    if (_this.from === "classificationPlanReview") {
                        _this.$router.push("/ClassificationPlanReview");
                    } else {
                        _this.$router.push("/ClassificationPlan");
                    }
                },10);


            }, 1000)


        },

        computed: {},
        methods: {
            setupPrintProperties(orientation) {
                let style = document.createElement('style');
                document.head.appendChild(style);
                style.innerHTML = '@page {size: A4 ' + orientation + '}';
            },
            stripScripts(s) {
                let div = document.createElement('div');
                div.innerHTML = s;
                let scripts = div.getElementsByTagName('script');
                let i = scripts.length;
                while (i--) {
                    scripts[i].parentNode.removeChild(scripts[i]);
                }
                return div.innerHTML;
            }
        }
    };
</script>

<style scoped>
    @media print {
        @page {

        }

    }
</style>




// WEBPACK FOOTER //
// src/pages/ClassificationPlanPrint.vue